module.exports = __webpack_public_path__ + "static/media/qr-code.c89be69c.svg";